var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#70797B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5999 1.7499C10.5999 1.41853 10.3313 1.1499 9.9999 1.1499C9.66853 1.1499 9.3999 1.41853 9.3999 1.7499V10.2499C9.3999 10.5813 9.66853 10.8499 9.9999 10.8499C10.3313 10.8499 10.5999 10.5813 10.5999 10.2499V1.7499ZM14.5927 4.077C14.3198 3.8889 13.9462 3.95757 13.7581 4.23038C13.57 4.50319 13.6387 4.87683 13.9115 5.06493C15.7179 6.31044 16.8999 8.39221 16.8999 10.7499C16.8999 14.5607 13.8107 17.6499 9.9999 17.6499C6.18914 17.6499 3.0999 14.5607 3.0999 10.7499C3.0999 8.39392 4.28016 6.31346 6.08439 5.06764C6.35707 4.87935 6.42549 4.50566 6.2372 4.23298C6.04891 3.9603 5.67523 3.89188 5.40254 4.08017C3.28774 5.54044 1.8999 7.98304 1.8999 10.7499C1.8999 15.2234 5.5264 18.8499 9.9999 18.8499C14.4734 18.8499 18.0999 15.2234 18.0999 10.7499C18.0999 7.98103 16.71 5.5369 14.5927 4.077Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPower);
export default __webpack_public_path__ + "static/media/icon-power.78c88e2d741f40b5ae3447083b2b6fc1.svg";
export { ForwardRef as ReactComponent };